"use strict";

//
// EVFMDCalculator.js
//

export default class EVFMDCalculator {

//
// Same for male and female.
//

    ageChangeFromFMD(fmd, age) {
        let ageChange;

        // Set limits.
        let limitedFMD = fmd;
        if (limitedFMD > 20) {
            limitedFMD = 20;
        } else if (limitedFMD < 0) {
            limitedFMD = 0;
        }

        // Get the neutral point.
        const neutralFMD = this.neutralFMDForAge(age);

        // Adjust.
        ageChange = (neutralFMD - limitedFMD);

        return this.roundToZero(ageChange);
    };

//
// Same for male and female.
//

    neutralFMDForAge(age) {
        return 14.104 + (-0.0832 * age);
    };

//
// Prevent values expressed with large negative exponents from
// throwing JavaScript off.
//

    roundToZero(value) {
        let roundedValue = value;

        if (value > -0.0001 && value < 0.0001) {
            roundedValue = 0.0;
        }

        return roundedValue;

    };


}
